import { MDXRemoteSerializeResult } from "next-mdx-remote";
import {
  StrapiCookieCategoryDTO,
  CookieCategoryDTO,
} from "@lib/strapi/dtos/components/cookies/cookieCategory.dto";

export class StrapiCookieBannerDTO {
  constructor() {}

  heading: string;
  prompt: string;
  acceptAllLabel: string;
  rejectAllLabel: string;
  savePreferencesLabel: string;
  policyLinkLabel: string;
  policyLinkUrl: string;
  categories: StrapiCookieCategoryDTO[];
}

export class CookieBannerDTO {
  constructor() {}

  extraData: any = {};
  heading: string;
  prompt: MDXRemoteSerializeResult;
  acceptAllLabel: string;
  rejectAllLabel: string;
  savePreferencesLabel: string;
  policyLinkLabel: string;
  policyLinkUrl: string;
  categories: CookieCategoryDTO[];
}
